<template>
  <!-- 根据tableData的值去显示隐藏列表 -->
  <div style="height:100%">
    <div class="Main" style="padding-bottom:0;" v-if="empty">
      <div class="topMain">
        <div slot="header" class="clearfix">
          <span>设备协议库</span>


          <el-button style="float: right;" type="primary" @click="uploadBtn" v-has="'equipmentProtocolLibrary:import'">
            导入
          </el-button>

          <el-button style="float: right;margin-right:20px" v-if="multipleSelection.length == 0" type="primary"
            @click="addBtn">创建
          </el-button>
          <div style="float: right;" v-if="multipleSelection.length != 0">
            <span>已选中<i class="checkedNumb"> {{ multipleSelection.length }}</i>
              个</span>
            <el-dropdown trigger="click" @command="operationBtn">
              <span class="el-dropdown-link">
                操作<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="{ type: 'del', para: multipleSelection }">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
      </div>

      <div class="coreMain">
        <div>
          <el-input class="input-with-select" placeholder="输入协议名称搜索" v-model="search" @keyup.enter.native="searchBtn">
          </el-input>
          <el-select v-model="type" placeholder="请选择协议类型" @change="getMyprotocol">
            <el-option v-for="item in protocolTypes" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
          <el-button @click="searchBtn" icon="el-icon-search" type="primary"></el-button>
          <el-button class="clearSearch" type="text" @click="reset">清除搜索条件</el-button>
        </div>
        <el-table v-loading="loading" ref="multipleTable" :data="tableData" style="width: 100%">
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column label="名称" min-width="150px">
            <template slot-scope="scope">
              <el-link :underline="false" class="tableButton" type="primary" @click="detailBtn(scope.row.id)">
                {{ scope.row.name }}</el-link>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="code" label="编号"></el-table-column> -->
          <el-table-column prop="protocolType" label="解析方式">
            <template slot-scope="scope">
              <span v-if="scope.row.protocolType==1">脚本解析</span>
              <span v-else-if="scope.row.protocolType==2">模板解析</span>
              <span v-else>---</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" prop="remarks"></el-table-column>
          <el-table-column label="创建人" prop="creator"></el-table-column>
          <el-table-column label="创建时间" prop="createDate" :formatter="formatDate"></el-table-column>
          <el-table-column label="">
            <template slot-scope="scope">
              <el-dropdown class="briefDetails" style="top:22px;right:32px" @command="command">
                <span class="el-dropdown-link">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    v-if="(scope.row.type != 1 && user_name != 'suadmin') || (scope.row.type == 1 && user_name == 'suadmin')"
                    :command="{ type: 'edit', row: scope.row }">编辑</el-dropdown-item>
                  <el-dropdown-item v-if="scope.row.type != 1 && user_name == 'suadmin'"
                    :command="{ type: 'upgrade', row: scope.row }">升级</el-dropdown-item>
                  <el-dropdown-item
                    v-if="(scope.row.type != 1 && user_name != 'suadmin') || (scope.row.type == 1 && user_name == 'suadmin')"
                    :command="{ type: 'del', row: scope.row }">删除</el-dropdown-item>
                  <el-dropdown-item :command="{ type: 'export', row: scope.row }">导出</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>
    <!-- 没有网关显示的内容 -->
    <div class="emptyMain" v-if="!empty">
      <el-card class="box-card">
        <img src="../../assets/images/wangguan.png" alt="" />
        <p style="color:#303133">您还没有创建任何设备协议</p>
        <br />
        <el-button>了解详情</el-button>
        <el-button type="primary" @click="addBtn">创建设备协议</el-button>
      </el-card>
    </div>

    <el-dialog title="导入设备协议" :visible.sync="dialogFormVisible">
      <el-form ref="uploadForm" :model="uploadForm">
        <el-form-item label="文件上传：" prop="attachmentId" style="width: 350px;">
          <el-upload ref="uploadRef" :action='upload' accept=".json" :data="tokenData" show-file-list
            class="upload-demo" :limit='1' :auto-upload="false" :file-list="attachmentIdFileList"
            :on-success='uploadSuccess' :on-remove='uploadRemove' :on-error="uploadError" drag :with-credentials='true'
            :headers="myHeaders" :on-change="uploadCharge">
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
            <div style="margin-top: 2px">只能上传json文件，其他类型文件将无法成功创建协议。</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="导入类型：" prop="importMode">
          <el-radio v-model="uploadForm.importMode" label="1">新增</el-radio>
          <el-radio v-model="uploadForm.importMode" label="2" @change="importModeChange">覆盖</el-radio>
        </el-form-item>
        <el-form-item label="要覆盖的设备协议：" prop="devProtocolId" v-if="uploadForm.importMode == 2">
          <el-select v-model="uploadForm.devProtocolId" filterable placeholder="未选择">
            <el-option v-for="item in devProtocolList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="importExcel">导入</el-button>
        <el-button @click="uploadCancel">关闭</el-button>
      </div>

    </el-dialog>

    <!-- 删除结果弹出框 -->
    <el-dialog :title="'删除结果'" :visible.sync="delErrorMsgMaskVisible" width="30%" :close-on-click-modal="false">
      <el-table ref="multipleTable" :data="delErrorMsgTableData" :border="true">
        <el-table-column prop="code" label="编号" align="center"></el-table-column>
        <el-table-column prop="errorMsg" label="错误信息">
          <template slot-scope="scope">
            <span style="color: #ff0000;">{{ scope.row.errorMsg }}</span>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="delErrorMsgResultOff">关 闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
  import API from "../../api/api";
  import dayjs from 'dayjs'
  export default {
    data() {
      return {
        uploadForm: {
          devProtocolId: '',
          importMode: '1'
        },
        delErrorMsgMaskVisible: false,
        delErrorMsgTableData: [],
        user_name: this.$cookies.get("user_name"),
        loading: false,
        empty: false, //控制数据为空展示空页面
        total: 0,
        currentPage: 1,
        pageSize: 10,
        search: "", //搜索
        model: [],
        modelList: [],
        categoryId: [],
        deviceClass: [], //设备分类
        deviceClassList: [], //设备分类下拉数据
        tableData: [], //我的协议
        multipleSelection: [], //我的协议-选中的值
        dialogFormVisible: false,
        attachmentIdFileList: [],
        upload: API.importDevProtocolUrl(), //上传地址
        type: 0,
        protocolTypes: [{
            value: 0,
            label: '全部协议'
          },
          {
            value: 1,
            label: '平台协议'
          },
          {
            value: 2,
            label: '自有协议'
          }
        ],
        devProtocolList: [],
        myHeaders: {
          Authentication: this.$cookies.get('token')
        },
        fileCount: 0
      };
    },
    computed: {
      tokenData: function () {
        return {
          access_token: this.$cookies.get('access_token'),
          commuType: sessionStorage.getItem("commuType"),
          importMode: this.uploadForm.importMode,
          devProtocolId: this.uploadForm.devProtocolId,
        }
      }
    },
    created() {},
    methods: {

      uploadCancel() {
        this.attachmentIdFileList = []
        this.fileCount = 0
        this.devProtocolList = []
        this.uploadForm.importMode = '1'
        this.dialogFormVisible = false;
      },

      uploadCharge(file, fileList) {
        this.fileCount = fileList.length
        // console.log("uploadCharge>", this.fileCount);
      },

      importExcel() {
        if (this.fileCount == 0) {
          this.$message.warning('请选择文件')
          return false
        }
        if (this.uploadForm.importMode == '2') {
          this.$confirm("此操作将覆盖原有数据, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(() => {
              this.$refs.uploadRef.submit();
            })
        } else {
          this.$refs.uploadRef.submit();
        }


      },

      importModeChange(mode) {
        if (mode == 2 && this.devProtocolList.length == 0) {
          this.getProtocolList();
        }
      },

      //查询设备协议下拉数据
      getProtocolList() {
        let param = {
          commuType: sessionStorage.getItem('commuType')
        };
        API.platformDevDeviceProtocol(param).then(res => {
          if (res.code == 1) {
            this.devProtocolList = res.data;
          }
        });
      },

      formatDate(row, column, cellValue, index) {
        if (row.createDate) {
          return dayjs(new Date(row.createDate)).format("YYYY-MM-DD HH:mm:ss")
        } else {
          return '--'
        }
      },

      uploadError() {
        this.$message.error('上传出错')
      },
      uploadRemove() {},
      uploadSuccess(e) {
        if (e.code === 1) {
          this.$message.success('上传成功')
          this.getMyprotocol();
        } else {
          this.$message.error(e.msg)
          // this.attachmentIdFileList = []
          // this.fileCount = 0
        }

      },

      uploadBtn() {
        this.dialogFormVisible = true;
      },

      //初始化页面
      init() {
        //获取私有协议数据
        let para = {
          commuType: sessionStorage.getItem('commuType'),
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          type: this.type,
        };
        API.platformDevProtocolSelfPage(para).then(res => {
          if (res.code == 1) {
            this.tableData = res.data.resultPage;
            this.total = res.data.total;
          }
        });
        //设备品牌型号级联数据
        API.platformDevProtocolBrandAndModel().then(res => {
          if (res.code == 1) {
            this.modelList = res.data.brandAndModel;
          }
        });
        //获取设备分类树形数据
        API.platformDevCategoryDevCategoryList().then(res => {
          if (res.code == 1) {
            this.deviceClassList = res.data.devCategoryTreeList;
          }
        });
        if (
          this.tableData.length == 0
        ) {
          this.empty = true; //没有数据显示空页面
        } else {
          this.empty = false; //没有数据显示空页面
        }
      },
      //获取私有协议数据
      getMyprotocol() {
        let para = {
          commuType: sessionStorage.getItem('commuType'),
          brand: this.model[0],
          model: this.model[1],
          name: this.search, //搜索栏
          categoryId: this.categoryIdStr, //设备分类
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          type: this.type,
        };
        API.platformDevProtocolSelfPage(para).then(res => {
          if (res.code == 1) {
            this.tableData = res.data.resultPage;
            this.total = res.data.total;
          }
        });
      },
      //搜索功能
      searchBtn() {
        this.currentPage = 1;
        this.getMyprotocol();
      },
      //清除搜索条件
      reset() {
        this.type = 2;
        this.search = "";
        this.model = [];
        this.categoryId = [];
        this.categoryIdStr = "";
        this.currentPage = 1;
        this.getMyprotocol();

      },
      //操作
      operationBtn(val) {
        if (val.type == "del") {
          let str = val.para.join(",");
          this.delBtn(str);
        }
      },
      //选中我的协议
      selectionBtn(val) {
        if (val.flag == false) {
          var index = this.multipleSelection.indexOf(val.id); //先获取取消选中按钮的下标
          if (index > -1) {
            //大于-1证明存在，然后splice删除
            this.multipleSelection.splice(index, 1);
          }
        }
        if (val.flag == true) {
          //选中的赋值给multipleSelection
          this.multipleSelection.push(val.id);
        }
      },
      //删除功能---批量删，单独删都能用
      delBtn(delId) {
        let para = {
          ids: delId
        };
        this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
          .then(() => {
            if (this.user_name == 'suadmin') {
              API.delPlatformDevProtocolDeviceProtocolCommon(para).then(res => {
                if (res.code == 1) {
                  this.$message.success("删除成功");
                  this.getMyprotocol();
                } else {
                  var falseList = res.data;
                  this.delErrorMsgTableData = [];
                  this.tableData.forEach(item => {
                    falseList.forEach(errMsg => {
                      if (errMsg.indexOf(item.id) != -1) {
                        this.delErrorMsgTableData.push({
                          code: item.name,
                          errorMsg: errMsg.substring(errMsg.indexOf('删除失败'))
                        })
                        return;
                      }
                    })
                  });
                  this.delErrorMsgMaskVisible = true;
                }
              });
              return;
            }
            API.delPlatformDevProtocolDeviceProtocolPrivate(para).then(res => {
              if (res.code == 1) {
                this.$message.success("删除成功");
                this.getMyprotocol();
              } else {
                var falseList = res.data;
                this.delErrorMsgTableData = [];
                this.tableData.forEach(item => {
                  falseList.forEach(errMsg => {
                    if (errMsg.indexOf(item.id) != -1) {
                      this.delErrorMsgTableData.push({
                        code: item.name,
                        errorMsg: errMsg.substring(errMsg.indexOf('删除失败'))
                      })
                      return;
                    }
                  })
                });
                this.delErrorMsgMaskVisible = true;
              }
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
      },
      //关闭删除结果
      delErrorMsgResultOff() {
        this.delErrorMsgMaskVisible = false;
        this.getpageList();
      },
      //点击操作
      command(para) {
        let id = para.row.id;
        if (para.type == "edit") {
          //编辑
          this.$router.push({
            path: "/equipment/equimentProtocolAdd",
            query: {
              id: id,
              flag: "edit"
            }
          });
        } else if (para.type == "del") {
          //删除
          this.delBtn(id);
        } else if (para.type == "export") {
          //导出
          let token = this.$cookies.get('access_token');
          let url = id + "&access_token=" + (token ? token : '');
          window.open(API.exportDevProtocolUrl(url))
        } else if (para.type == "upgrade") {
          API.upgradePlatformDevProtocol(id)
            .then(res => {
              if (res.code == 1) {
                this.$message({
                  message: "升级成平台设备协议成功！",
                  type: "success"
                });
              } else {
                this.$message({
                  message: res.msg,
                  type: "error"
                });
              }
            });
        }
      },
      //跳转详情页
      detailBtn(id) {
        this.$router.push({
          path: "/equipment/equimentProtocolDetails",
          query: {
            id: id
          }
        });
      },
      //跳转创建设备协议页
      addBtn() {
        this.$router.push({
          path: "/equipment/equimentProtocolAdd"
        });
      },
      //分页
      handleCurrentChange(val) {
        this.currentPage = val;
        this.getMyprotocol();
      },
      handleSizeChange(val) {
        this.pageSize = val;
        this.currentPage = 1;
        this.getMyprotocol();
      },
    },
    mounted() {
      this.init();
    }
  };

</script>



// WEBPACK FOOTER //
// src/views/platform/equipmentProtocolLibrary.vue